"use strict";
var ng_table_component_1 = require('./table/ng-table.component');
var ng_table_filtering_directive_1 = require('./table/ng-table-filtering.directive');
var ng_table_paging_directive_1 = require('./table/ng-table-paging.directive');
var ng_table_sorting_directive_1 = require('./table/ng-table-sorting.directive');
exports.NG_TABLE_DIRECTIVES = [ng_table_component_1.NgTableComponent, ng_table_filtering_directive_1.NgTableFilteringDirective, ng_table_paging_directive_1.NgTablePagingDirective, ng_table_sorting_directive_1.NgTableSortingDirective];



//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/ng2-table/components/ng-table-directives.js
// module id = ../../../../ng2-table/components/ng-table-directives.js
// module chunks = 4